import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FilterMatchMode, FilterService } from 'primereact/api'
import { capitalizeFirstLetter, dynamicCustomFilter, handleInput, handleInventory } from '../../../utility/genricFunction'
import { Box, Typography } from '@mui/material'
import { ErrorMessage, Formik } from 'formik'
import NewInput from '../../../components/input/NewInput'
import { numbers, permissions, ROUTES_PATH, UI_CONSTANT } from '../../../utility/constants'
import Button from '../../../components/button/Button'
import { mangeInventory } from '../../../store/builders/inventory/inventory.builder'
import PageDropdown from '../../../components/page-dropdown/PageDropdown'
import { Dropdown } from 'primereact/dropdown'
import PopupBox from '../../../components/popup/PopupBox'
import HorizontalLine from '../../../assets/icons/Line33.svg'
import pencilIcon from "../../../assets/icons/pencil1.svg"
import ModalUnstyled from '../../../components/model/Model'
import closeIcon from '../../../assets/icons/close.svg'
import { VALIDATION_MESSAGES } from '../../../utility/constantValidationMessages'
import RightDrawer from '../../../components/drawer/Drawer'
import Loader from '../../../components/loader/Loader'
import BreadCrumbs from '../../../components/breadcrumb/Breadcrumb'
import ParentDataTable from '../../../components/data-table/ParentDataTable'
import UseAuthorization from '../../../utility/useAuthorization'
import { addEducationQualification, editEducationQualification, getEducationQualification } from '../../../store/builders/masterDataSet/masterDataSet.builder'

export default function EducationQualificationList() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const loading = useSelector((state) => state.masterDataSet.loading)
  const [archiveId, setArchiveId] = useState('')
  const [singleInventoryData, setSingleInventoryData] = useState('')

  const educationQualificationData = useSelector(store=>store?.masterDataSet?.educationQualificationData)

  const branchList = useSelector((store) => store.branch.branchTableData)

  const branches = branchList.map((branch) => {
    return { label: branch.branchName, value: branch.branchId }
  })

  const handleBranchDropdownChange = (value, setFieldValue) => {
    setFieldValue('branchName', value)
  }

  useEffect(() => {
    dispatch(getEducationQualification())
  }, [])

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)

  FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    educationQualificationName: { value: null, matchMode: 'dynamic_custom' },
    educationQualificationStatus: { value: null, matchMode: FilterMatchMode.EQUALS },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
  })

  const [open, setOpen] = useState(false)
  const [inventoryDrawerOpen, setInventoryDrawerOpen] = useState(false)
  const [editInventoryDrawer, setEditInventoryDrawer] = useState(false)
  const [openArchive, setOpenArchive] = useState(false)
  const [filteredData, setFilteredData] = useState([])
  const [filterNumber, setfilterNumber] = useState(false)

  const [selectedValue, setSelectedValue] = useState(null)

  const statuses = [
    { label: 'active', value: 'active' },
    { label: 'inactive', value: 'inactive' },
  ]

  useEffect(() => {
    setFilteredData(educationQualificationData)
  }, [educationQualificationData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(educationQualificationData, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen)
  }

  const toggleDrawerForAddInventory = (newOpen, inquirySourceData) => () => {
    setInventoryDrawerOpen(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inquirySourceData)
  }

  const toggleDrawerForEditInventory = (newOpen, inquirySourceData) => () => {
    setEditInventoryDrawer(newOpen)
    setIsOpen(true)
    setSingleInventoryData(inquirySourceData)

  }

  const validationSchema = Yup.object().shape({
    educationQualificationName: Yup.string().required(VALIDATION_MESSAGES.EDUCATION_QUALIFICATION),
  })

  const DrawerList = ({data, edit})=>{

   const [initialValues, setInitialValues] = useState({
      educationQualificationName: data?.educationQualificationName ? data?.educationQualificationName : "",
      educationQualificationId: data?.educationQualificationId ? data.educationQualificationId : "",
      educationQualificationStatus: data?.educationQualificationStatus ? data?.educationQualificationStatus : "",
    })


    return <Box className='timetable-drawer' role='presentation'>
      <Box className='timetable-drawer-header flex justify-between align-center'>
        <Typography className='timetable-drawer-title'>
          {UI_CONSTANT.MASTER_CONFIG.EDUCATION_QUALIFICATION.ADD_EDUCATION_QUALIFICATION}
        </Typography>
        <img className='timetable-drawer-icon' src={closeIcon} alt='Close' onClick={toggleDrawer(false)} />
      </Box>
      <Box className='drawer-horizontal-line' />

      <Formik
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={(value) => {
          const data = {
            value,
            setOpen,
          }

          if(edit){
            dispatch(editEducationQualification({value, setEditInventoryDrawer}))
          }else{
            dispatch(addEducationQualification(data))
          }

          
        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue, errors }) => (
          <form>
            <div className='full-form'>
              <div className='first-row'>
                <NewInput
                  label='Education Qualification'
                  placeholder='Enter education qualification'
                  name='educationQualificationName'
                  width={'50%'}
                  required={true}
                  // onInput={handleInventory}
                />
              </div>
            </div>

                {
                  edit && <div className='drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Education Qualification Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}
                    selectedValue={values.educationQualificationStatus}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'educationQualificationStatus'}
                    placeholder={'Select Status'}
                  />
                  <ErrorMessage name='educationQualificationStatus' component='div' className='error-msg' />
                </div>
                }

            <div className='right-drawer-save'>
              <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                {UI_CONSTANT.SUBMIT}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Box>
}

  const handleManageInventoryFormSubmit = (value) => {
    const data= {
      value,
      setInventoryDrawerOpen
    }
    dispatch(mangeInventory(data))
  }

  const InquirySourceDrawerList = (data) => {
    const manageInventoryValidationSchema = Yup.object().shape({
      branchName: Yup.string().required('Branch Name is required'),
      branchMaterialQuantity: Yup.number()
        .required('Quantity is required')
        .max(data?.data?.quantity, `Quantity should not be greater than ${data?.data?.quantity}`),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>Manage Inventory</Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForAddInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            branchMaterialQuantity: '',
            materialId: data?.data?.materialId,
            branchName: '',
          }}
          validationSchema={manageInventoryValidationSchema}
          onSubmit={(value) => {
            handleManageInventoryFormSubmit(value)
          }}
        >
          {({ values, handleChange, handleSubmit, setFieldValue }) => (
            <form>
              <div className='full-form'>
                <div className='first-row'>
                  <NewInput
                    label='Inventory Quantity'
                    placeholder='Enter inventory quantity'
                    name='branchMaterialQuantity'
                    width={'50%'}
                    type={'number'}
                    required={true}
                    onInput={handleInput}
                  />

                  <div className='first-field w-50'>
                    <label className='branch-title-inp padding-top-0' htmlFor=''>
                      Branch
                      <span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={branches}
                      selectedValue={values.branchName}
                      className={'branch-dropdown'}
                      onChange={(e) => handleBranchDropdownChange(e.target.value, setFieldValue)}
                      name={'branchName'}
                      placeholder={'Select branch'}
                    />
                    <ErrorMessage name='branchName' component='div' className='error-msg' />
                  </div>
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const handleEditEducationQualification = (value) => {
    const data = {
      value,
      setEditInventoryDrawer,
    }
    dispatch(editEducationQualification(data))
    
  }

  const EditInquirySourceDrawerList = (data) => {
    const editInventoryValidationSchema = Yup.object().shape({
      educationQualificationName: Yup.string().required(VALIDATION_MESSAGES.EDUCATION_QUALIFICATION),
    })

    return (
      <Box className='timetable-drawer' role='presentation'>
        <Box className='timetable-drawer-header flex justify-between align-center'>
          <Typography className='timetable-drawer-title'>
            {UI_CONSTANT.MASTER_CONFIG.EDUCATION_QUALIFICATION.EDIT_EDUCATION_QUALIFICATION}
          </Typography>
          <img
            className='timetable-drawer-icon'
            src={closeIcon}
            alt='Close'
            onClick={toggleDrawerForEditInventory(false)}
          />
        </Box>
        <Box className='drawer-horizontal-line' />

        <Formik
          initialValues={{
            educationQualificationName: data?.data?.educationQualificationName,
            educationQualificationId: data.data.educationQualificationId,
            educationQualificationStatus: data.data.educationQualificationStatus,
          }}
          validationSchema={editInventoryValidationSchema}
          onSubmit={(value) => {
            handleEditEducationQualification(value)
          }}
        >
          {({ values, handleChange, handleSubmit, setFieldValue }) => (
            <form>
              <div className='designation-field-wrapper flex justify-between'>
                <div className='designation-drawer-input'>
                  <div className='designation-drawer-input-label'>
                    <NewInput
                      label='Education Qualification'
                      placeholder='Enter education qualification'
                      name='educationQualificationName'
                      width={'100%'}
                      type={'text'}
                      required={true}
                      value={values.educationQualificationName}
                      // onInput={handleInventory}
                    />
                  </div>
                </div>

                <div className='designation-drawer-input1'>
                  <label className='designation-drawer-input-label' htmlFor=''>
                    Education Qualification Status <span className='required-symbol'>*</span>
                  </label>
                  <PageDropdown
                    options={statuses}
                    selectedValue={values.educationQualificationStatus}
                    className={'designation-drawer-option'}
                    onChange={handleChange}
                    name={'educationQualificationStatus'}
                    placeholder={'Select Status'}
                  />
                  <ErrorMessage name='educationQualificationStatus' component='div' className='error-msg' />
                </div>
              </div>

              <div className='right-drawer-save'>
                <Button customClassName={'drawer-save-btn'} onClick={handleSubmit}>
                  {UI_CONSTANT.SUBMIT}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Box>
    )
  }

  const nameBody = (educationQualificationData) => {
    const representative = educationQualificationData?.educationQualificationName && capitalizeFirstLetter(educationQualificationData?.educationQualificationName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }
  const statusBody = (educationQualificationData) => {
    const representative = educationQualificationData?.educationQualificationStatus && capitalizeFirstLetter(educationQualificationData?.educationQualificationStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
      // style={{ minWidth: '12rem' }}
      />
    )
  }

  const handleArchiveConfirm = (inquiryId) => {
    // dispatch(inquiryArchive({ inquiryId })) // Example action
    setOpenArchive(false)
  }

  const verifiedBodyTemplate = (inquirySourceData) => {
    const handleRowClick = (id) => {
      const path = ROUTES_PATH.EDIT_ENROLLMENT.replace(':id', id)
      navigate(path)
    }

    return (
      <>
        <PopupBox rowData={inquirySourceData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            <p className='verifiedBodyTemplate-Assign'>{UI_CONSTANT.POP_UP_ACTION}</p>

            <img src={HorizontalLine} alt='' />

            {UseAuthorization(permissions.EDIT_INVENTORY) && (
              <button className='div-assign-to-branch' onClick={toggleDrawerForEditInventory(true, inquirySourceData)}>
                <img src={pencilIcon} alt='' />
                <p className='verifiedBodyTemplate-darkfont'>Edit education qualification</p>
              </button>
            )}

          </div>
        </PopupBox>
        
        <RightDrawer anchor='right' isOpen={inventoryDrawerOpen} onClose={toggleDrawerForAddInventory(false)}>
          <InquirySourceDrawerList data={singleInventoryData} />
        </RightDrawer>


        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            BottomButton2={'No'}
            className={'archive-model'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => handleArchiveConfirm(archiveId)}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'educationQualificationName',
      header: 'Inquiry Source',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'educationQualificationStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { minWidth: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.MASTER_CONFIG.EDUCATION_QUALIFICATION.LABEL_EDUCATION_QUALIFICATION,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INVENTORY.LABEL_INVENTORY,
      link: ROUTES_PATH.INVENTORY,
    },
  ]

  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}

      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            {UseAuthorization(permissions.ADD_INVENTORY) && (
              <Button className='add-btn' onClick={toggleDrawer(true)}>
                {UI_CONSTANT.MASTER_CONFIG.EDUCATION_QUALIFICATION.ADD_EDUCATION_QUALIFICATION}
              </Button>
            )}
          </div>
          <RightDrawer anchor='right' isOpen={open} onClose={toggleDrawer(false)}>
            <DrawerList/>
          </RightDrawer>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>
                {UI_CONSTANT.MASTER_CONFIG.EDUCATION_QUALIFICATION.ALL_EDUCATION_QUALIFICATION}
              </b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => setSelectedNumber(e.value)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>

          <div id='inventory-list-table' className='table-card'>
            <ParentDataTable
              value={filteredData}
              rows={filterNumber ? filteredData.length : selectedNumber}
              filters={filters}
              // loading={loading}
              columns={columns}
              onFilter={onFilter}
            />
          </div>
        </div>
        {/* <9/div> */}
        {editInventoryDrawer && (
          <RightDrawer anchor='right' isOpen={editInventoryDrawer} onClose={toggleDrawerForEditInventory(false)}>
            <DrawerList data={singleInventoryData} edit={true}/>
          </RightDrawer>
        )}
      </div>}
    </>
  )
}